export default {
  PAYMENTS: '1',
  DIRECTDEBIT: '2',
  DIRECTPAYMENTS: '6',
  DOCUMENTSERVICE: '7',
  SUPPLIERS: '8',
  VERIFICATIONS: '9'
}

export const getServiceId = (serviceName) => {
  switch (serviceName) {
    case 'payments':
      return '1'
    case 'exchangeDoc':
      return '2'
    case 'cloudDoc':
      return '3'
    case 'directDebit':
      return '4'
    case 'diamond':
      return '5'
    case 'directPayments':
      return '6'
    case 'suppliers':
      return '8'
    case 'verifications':
      return '9'
    default:
      return '1'
  }
}

export const getServiceName = (serviceId) => {
  switch (serviceId) {
    case '1':
      return 'payments'
    case '2':
      return 'exchangeDoc'
    case '3':
      return 'cloudDoc'
    case '4':
      return 'directDebit'
    case '5':
      return 'diamond'
    case '6':
      return 'directPayments'
    case '8':
      return 'suppliers'
    case '9':
      return 'verifications'
    default:
      return 'payments'
  }
}



// WEBPACK FOOTER //
// ./src/helpers/services.js